import { useNavigate, useLocation } from 'react-router-dom'
import { Shield, Scan, FolderOpen } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useProjectContext } from '@/lib/context/ProjectContext'

interface ComplianceLayoutProps {
    children: React.ReactNode
}

export default function ComplianceLayout({ children }: ComplianceLayoutProps) {
    const navigate = useNavigate()
    const location = useLocation()
    const { selectedProject } = useProjectContext()

    const getActiveTab = () => {
        if (location.pathname.includes('/compliance/configure-audit')) return 'configure-audit'
        if (location.pathname.includes('/compliance/security-scanning')) return 'security-scanning'
        return 'configure-audit'
    }

    const handleTabChange = (value: string) => {
        navigate(`/compliance/${value}`)
    }

    return (
        <div className="p-8 space-y-6">
            <div>
                <h1 className="text-3xl font-bold">Compliance</h1>
                <p className="text-muted-foreground mt-1">
                    {selectedProject ? (
                        <>
                            Compliance audits and security scanning for{' '}
                            <span className="font-medium text-foreground">{selectedProject.name}</span>
                        </>
                    ) : (
                        'Manage compliance audits and security scanning'
                    )}
                </p>
            </div>

            <Tabs value={getActiveTab()} onValueChange={handleTabChange} className="w-full">
                <TabsList className="grid w-full max-w-2xl grid-cols-2">
                    <TabsTrigger value="configure-audit">
                        <Shield className="h-4 w-4 mr-2" />
                        Compliance Auditing
                    </TabsTrigger>
                    <TabsTrigger value="security-scanning">
                        <Scan className="h-4 w-4 mr-2" />
                        Security Scanning
                    </TabsTrigger>
                </TabsList>
            </Tabs>

            {!selectedProject ? (
                <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-20">
                    <FolderOpen className="h-12 w-12 text-gray-300" />
                    <h3 className="mt-4 text-lg font-semibold text-gray-600">No Project Selected</h3>
                    <p className="text-sm text-muted-foreground mt-1">
                        Select a project from the header to continue.
                    </p>
                </div>
            ) : (
                children
            )}
        </div>
    )
}